import { combineReducers } from 'redux'
import { routerReducer as router } from 'react-router-redux'
import { reducer as formReducer } from 'redux-form'
import auth from '../components/Auth'

export const makeRootReducer = (asyncReducers) => (state, action) => {
  return combineReducers({
    auth: auth,
    form: formReducer,
    router,
    ...asyncReducers
  })(action.type === 'CLEAR_STATE' ? undefined : state, action)
}

export const injectReducer = (store, { key, reducer }) => {
  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export default makeRootReducer



// WEBPACK FOOTER //
// ./src/store/reducers.js